import { render } from "./fillInQPNew.vue?vue&type=template&id=405d7c66&scoped=true"
import script from "./fillInQPNew.vue?vue&type=script&lang=js"
export * from "./fillInQPNew.vue?vue&type=script&lang=js"

import "./fillInQPNew.vue?vue&type=style&index=0&id=405d7c66&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-405d7c66"

export default script